// extracted by mini-css-extract-plugin
export default {"base":"Error_base__m6bPs","headline":"Error_headline__tG3Ji","button":"Error_button__QOp-1","icon":"Error_icon__EAloR"};